import { useEffect, useRef } from "react";
import Author from "../../author";
import BuyCard from "../../buyCard";
import styles from "./index.module.css";
import VideoAlert from "../../../video-alert";
import PreAndNext from "../../preAndNext";
import Cast from "../../cast";
import Subscribe from "../../subscribe";
import LazyLoad from "react-lazyload";
const AtSecondSightDetail = ({
  isMobile,
  handleNextIndex,
  handleLastIndex,
  playVideo,
  pauseVideo,
  setInputFocus,
  movieData,
}) => {
  useEffect(() => {
    new VideoAlert(
      {
        havePathElement: `.${styles.btsPlayButton}`,
        openAlert: pauseVideo,
      },
      []
    );
  });
  return (
    <div className={styles.ctn}>
      <div className={styles.movieInfo}>
        <div className={styles.movieNameBox}>
          <img
            src="https://bucket.zhiyun-tech.com/detail/sm5sfilm2022/sm5sfilm2022-1-1.jpg"
            alt=""
            className={styles.movieName}
          />
          <img
            src="https://bucket.zhiyun-tech.com/detail/sm5sfilm2022/sm5sfilm2022-1-2.jpg"
            alt=""
            className={styles.btsPlayButton}
            data-cursor-size="80px"
            data-video-src="https://bucket.zhiyun-tech.com/detail/sm5sfilm2022/sm5sfilm2022-bts-01.mp4"
          />
        </div>

        <img
          src={`https://bucket.zhiyun-tech.com/detail/sm5sfilm2022/sm5sfilm2022-1-3${
            isMobile ? "-m" : ""
          }.jpg`}
          alt=""
          className={styles.author}
        />
      </div>

      <div>
        <LazyLoad offset={300}>
          <video
            autoPlay
            loop
            playsInline
            muted
            preload="true"
            src="https://bucket.zhiyun-tech.com/detail/sm5sfilm2022/sm5sfilm2022-1-4.mp4"
            poster="https://bucket.zhiyun-tech.com/detail/sm5sfilm2022/sm5sfilm2022-1-4-cover.jpg"
            className={styles.abMedia1}
          ></video>
        </LazyLoad>

        <img
          src={`https://bucket.zhiyun-tech.com/detail/sm5sfilm2022/sm5sfilm2022-1-5${
            isMobile ? "-m" : ""
          }.png`}
          alt=""
        />
      </div>

      <div>
        <LazyLoad offset={300}>
          <video
            autoPlay
            loop
            playsInline
            muted
            preload="true"
            src="https://bucket.zhiyun-tech.com/detail/sm5sfilm2022/sm5sfilm2022-1-6.mp4"
            poster="https://bucket.zhiyun-tech.com/detail/sm5sfilm2022/sm5sfilm2022-1-6-cover.jpg"
            className={styles.abMedia2}
          ></video>
        </LazyLoad>

        <img
          src={`https://bucket.zhiyun-tech.com/detail/sm5sfilm2022/sm5sfilm2022-1-7${
            isMobile ? "-m" : ""
          }.png`}
          alt=""
        />
      </div>

      <div>
        <LazyLoad offset={300}>
          <video
            autoPlay
            loop
            playsInline
            muted
            preload="true"
            src="https://bucket.zhiyun-tech.com/detail/sm5sfilm2022/sm5sfilm2022-1-8.mp4"
            poster="https://bucket.zhiyun-tech.com/detail/sm5sfilm2022/sm5sfilm2022-1-8-cover.jpg"
            className={styles.abMedia3}
          ></video>
        </LazyLoad>

        <img
          src={`https://bucket.zhiyun-tech.com/detail/sm5sfilm2022/sm5sfilm2022-1-9${
            isMobile ? "-m" : ""
          }.png`}
          alt=""
        />
      </div>

      <div>
        <LazyLoad className={styles.abMedia4} offset={300}>
          <video
            autoPlay
            loop
            playsInline
            muted
            preload="true"
            src="https://bucket.zhiyun-tech.com/detail/sm5sfilm2022/sm5sfilm2022-1-10.mp4"
            poster="https://bucket.zhiyun-tech.com/detail/sm5sfilm2022/sm5sfilm2022-1-10-cover.jpg"
            // className={styles.abMedia4}
          ></video>
        </LazyLoad>

        <img
          src={`https://bucket.zhiyun-tech.com/detail/sm5sfilm2022/sm5sfilm2022-1-11${
            isMobile ? "-m" : ""
          }.png`}
          alt=""
        />
      </div>
      <Cast
        movieName={movieData.name}
        data={[
          {
            post: "SHE",
            name: "NATALI VOITKEVICH",
          },
          {
            post: "HE",
            name: "EUGENE VASILEVICH",
          },
          {
            post: "KID",
            name: "ARSENIJ VOLNY",
          },
          {
            post: "PASSERS-BY",
            name: "NIKOLAI SAFONCEV, KSENIA KONOVSHAYA, ALISA KORMACH, SERGEY TIMOKHIN, ARINA GORIACHEVA, SERGE ZHURUK, DMITRY MANANNIKOF, TAISIA KONOVSHAYA, ROSTIK RIST, PETR SHPERNAL, VOVA ZHURUK",
          },
          {
            post: "WRITER/DIRECTOR/DP",
            name: "DMITRY VOLNY",
          },
          {
            post: "MAKEUP",
            name: "ALTYN SAFONTSEVA",
          },
          {
            post: "EDITOR",
            name: "DMITRY VOLNY",
          },
          {
            post: "COLOR",
            name: "ARTYOM RAKHMATULAEV",
          },
          {
            post: "SOUND",
            name: "ILYA PISOTSKI",
          },
          {
            post: "MUSIC",
            name: "IAN POST",
          },
          {
            post: "ASSISTENT",
            name: "DMITRY MANANNIKOF",
          },
          {
            post: "BTS",
            name: "IGOR KRENTS",
          },
        ]}
      />
    </div>
  );
};

export default AtSecondSightDetail;
